import { get, patch, put } from "helpers/api_helper";

export const apiGetListArticles = (params = {}) => {
  return get(`/master/news/`, {
    params: {
      page: 1,
      limit: 20,
      ...params,
    },
  });
};

/**
 *
 * @param {
 * news_ids: []string,
 * type: 'PUBLISH' | 'HIDDEN' | 'DELETE'
 * } body
 * @returns
 */
export const apiUpdateStatusArticles = (body = {}) => {
  return patch(`/master/news/update-status`, body);
};

export const apiCreateArticles = (body = {}) => {
  return put(`/master/news/`, body);
};

export const apiUpdateArticles = ({ id, ...body }) => {
  return patch(`/master/news/${id}`, body);
};

export const apiGetDetailArticles = (id) => {
  return get(`/master/news/${id}`);
};
